/**
 * @fileoverview This file contains the top contents of the website.
 */

import { Link } from "react-router-dom";
import { TableRow } from "../components/TableRow";
import { ContactLink } from "../components/ContactLink";
import LinkList from "../components/LinkList";

/**
 * Top contents
 * @returns {JSX.Element} GasLogReaderトップページの JSX element
 */
export function TopContents(): JSX.Element {
  /**
   * トラブルシューティングの項目のリンクリスト
   */
  const items = [
    { to: "/gas-log-reader/HelpAndSupport", text: "トラブルシューティング" },
  ];

  /**
   * ダウンロードの項目のリンクリスト
   */
  const downloadLinkList = [
    { to: "/gas-log-reader/Terms", text: "利用規約" },
    { to: "/gas-log-reader/PrivacyPolicy", text: "プライバシーポリシー" },
    { to: "/gas-log-reader/HowToDownload", text: "ダウンロード方法" },
    {
      to: "/gas-log-reader/HowToInstallDeviceDriver",
      text: "デバイスドライバーのインストール方法",
    },
    { to: "/gas-log-reader/HowToUse", text: "GasLogReaderの使い方" },
  ];

  return (
    <div>
      <div className="c-section">
        <p className="c-text">
          ガス検知器のデータを読み取るためのアプリケーション「GasLogReader」をダウンロードできます。
          <br />
          下の「ダウンロードページへ」ボタンをクリックしてソフトウェアをダウンロードし、ドライバーソフトウェアをインストールしてください。
          <br />
          これにより、ロギングデータ読み取り装置GOC200-70を使用して、酸素・一酸化炭素検知警報器GOC-200のロギングデータをパソコンに取り込むことが可能になります。
        </p>
      </div>

      <section className="c-section">
        <h2 className="p-heading-2">ダウンロード Ver1.0(Release 2025.03.12)</h2>
        {/** 上マージン制御用のユーティリティ .u-mt-xx を使用。common.css の288行目から314行目を参照*/}
        <div className="c-wrapper c-wrapper--close-btn u-mt-30">
          <Link
            to="/gas-log-reader/Download"
            className="c-btn c-btn--default c-btn--block"
          >
            ダウンロードページへ
          </Link>
        </div>
        <LinkList items={downloadLinkList} />
      </section>

      <section className="c-section">
        <h2 className="p-heading-2">ソフトウェアのトラブルや疑問</h2>
        <LinkList items={items} />
      </section>

      <section className="c-section">
        <h2 className="p-heading-2">動作環境</h2>
        <table className="c-table">
          <tbody>
            <TableRow label="OS" value="Windows 10, 11" />
            <TableRow label="インターフェース" value="USB2.0" />
          </tbody>
        </table>
      </section>

      <ContactLink />
    </div>
  );
}
